import { api, getApiBaseUrl, getAuthToken } from './apiClient';

export type ReportPreview = {
  clinicName: string;
  therapistName: string;
  crp: string;
  approach: string;
  patientName: string;
  patientAge?: number;
  period: { start: string; end: string };
  summary: string;
  indicators: Array<{ id: string; name: string; domain: string; axis: string; score: number }>;
  evolutionGuidelines: string;
  clinicalNotes: string;
  patientReport: string;
  disclaimer: string;
};

export function fetchReportPreview(patientId: string, cycleId: string): Promise<ReportPreview> {
  return api.get<ReportPreview>(`/patients/${patientId}/cycles/${cycleId}/report`);
}

export function updateReportTexts(
  patientId: string,
  cycleId: string,
  data: Partial<Pick<ReportPreview, 'patientReport' | 'evolutionGuidelines' | 'clinicalNotes' | 'summary'>>,
): Promise<unknown> {
  return api.patch(`/patients/${patientId}/cycles/${cycleId}/report`, {
    patientReport: data.patientReport,
    evolutionGuidelines: data.evolutionGuidelines,
    clinicalNotes: data.clinicalNotes,
    aiInsight: data.summary,
  });
}

export async function downloadReportPdf(patientId: string, cycleId: string): Promise<Blob> {
  const base = getApiBaseUrl();
  const token = getAuthToken();
  const res = await fetch(`${base}/patients/${patientId}/cycles/${cycleId}/report/pdf`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error('Falha ao gerar PDF');
  return res.blob();
}
